import { AppBar, styled } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

export const StyledAppBarContainer = styled(AppBar)(({ theme }) => ({
  background:
    theme.palette.mode === "dark"
      ? "rgba(13, 27, 42, 0.88)"
      : `rgba(21, 101, 192, 0.93)`,
  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",
  boxShadow: "0 1px 24px rgba(0,0,0,0.18)",
  borderBottom: "1px solid rgba(255,255,255,0.08)",
  transition: "background 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
}));

export const StyledMenuIcon = styled(MenuIcon)(() => ({
  height: 28,
  width: 28,
}));
